import BaseSystemApi from 'api/BaseSystemApi';

export default class LoanOriginationSystemApi<Resource = unknown> extends BaseSystemApi<Resource> {
  protected origin = process.env.REACT_APP_LOS_API_URL;
}
